import { useEffect, useState } from "react";
import { DialogWrapper } from "../../../../shared/components/common/dialogWrapper";
import ButtonWrapper from "../../../../shared/formUtilities/useButton";
import DataTableGrid from "../../../../shared/formUtilities/useTable";
import { InitializeSurveyUsersDetail } from "../../reportsColumn";
import { Box } from "@mui/material";

export const SurveyUserDetailDialog = ({ detail = {
  row: null,
  currentPoint: null
}, onClose = () => { }, state }) => {

  const [surveyUsersList, setSurveyUsersList] = useState([]);
  const columns = InitializeSurveyUsersDetail();

  useEffect(() => {
    setSurveyUsersList(detail?.row?.ratings?.find(resp => resp?.rating === detail.currentPoint)?.items || []);
  }, [detail]);

  return <DialogWrapper
    maxWidth="md"
    state={state}
    onClose={() => {
      onClose(false);
    }}
    title={`List of users who gave a ${detail.currentPoint} rating`}
    content={
      <Box className="mt-4">
        <DataTableGrid
          hideSerialNumbers
          showDownloadCSV={false}
          // download={() => {
          //   onDownloadCSV();
          // }}
          name={'surveyUsersTbl'}
          columns={columns}
          records={surveyUsersList}
          isPagination={false}
          showEditColumnsButton={false}
        ></DataTableGrid>
      </Box>
    }
    actions={
      <ButtonWrapper
        label="Close"
        onClick={() => {
          onClose(false);
        }}></ButtonWrapper>
    }></DialogWrapper>;
};